import React from 'react';
import Get from './Get';
import Keep from './Keep';
import Grow from './Grow';
import { Collapse, Tab, Row, Col, Nav, NavItem } from 'react-bootstrap';
import { injectIntl } from 'react-intl';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import { IndexLinkContainer, LinkContainer } from 'react-router-bootstrap';

@injectIntl
export default class Analytics extends React.Component {
  render() {
    const { intl } = this.props;

    return (
      <BrowserRouter>
        <Row className="clearfix" style={{ margin: 'auto' }}>
          <Col md={12} xs={12}>
            <div
              className={'text-center'}
              style={{ marginLeft: 'auto', marginRight: 'auto' }}
            >
              <Tab.Container id="left-tabs-example" defaultActiveKey={'get'}>
                <Nav bsStyle="pills" justified>
                  <LinkContainer exact to="/startup_statistics/get">
                    <NavItem eventKey={1}>
                      {intl.formatMessage({ id: 'get_title' })}
                    </NavItem>
                  </LinkContainer>
                  <LinkContainer exact to="/startup_statistics/keep">
                    <NavItem eventKey="keep">
                      {intl.formatMessage({ id: 'keep_title' })}
                    </NavItem>
                  </LinkContainer>
                  <LinkContainer exact to="/startup_statistics/grow">
                    <NavItem eventKey="grow">
                      {intl.formatMessage({ id: 'grow_title' })}
                    </NavItem>
                  </LinkContainer>
                </Nav>
              </Tab.Container>
            </div>

            <Switch>
              <Route path="/startup_statistics/get" component={Get} />
              <Route path="/startup_statistics/keep" component={Keep} />
              <Route path="/startup_statistics/grow" component={Grow} />
            </Switch>
          </Col>
        </Row>
      </BrowserRouter>
    );
  }
}
